<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" class="text-center">
        <h3 class="font-weight-bold mb-4" style="color: #6d4c41">Confirmação de Inscrição</h3>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6" style="border-radius: 16px; text-align: center">
          <v-progress-circular v-if="aguardando" indeterminate color="primary" size="48" class="mb-4" />
          <div v-if="aguardando" class="mb-2 font-weight-medium">Aguarde, processando inscrição...</div>
          <v-alert
            v-if="!aguardando"
            :type="msnreturn.type || 'info'"
            class="mt-4"
            dense
            outlined
            border="left"
            prominent
            transition="scale-transition"
          >
            <p class="text-justify">{{ msnreturn.msn }}</p>
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import filtros from "@/libs/filters";
import RemocaoServices from "@/services/rh/RemocaoServices";

export default {
  name: "ConfimarInscricaoView",
  data: () => ({
    msnreturn: { msn: "", type: "" },
    aguardando: true,
  }),
  components: {},
  filters: filtros,
  computed: {},
  methods: {},
  async mounted() {
    const id = this.$route.query.id;

    if (!id) {
      //  this.$router.push({ name: "initPage" });
      return;
    }
    try {
      const data = await RemocaoServices.confirmarInscricao(id);
      if (data.success) {
        this.msnreturn.msn = data.data;
        this.msnreturn.type = "success";
      } else if (data.Error) {
        this.msnreturn.msn = data.data;
        this.msnreturn.type = "error";
      } else {
        this.msnreturn.msn = "Não foi possível confirmar a inscrição.";
        this.msnreturn.type = "error";
      }
    } catch (e) {
      this.msnreturn.msn = "Erro ao processar inscrição. Tente novamente mais tarde.";
      this.msnreturn.type = "error";
    } finally {
      this.aguardando = false;
    }
  },
};
</script>

<style scoped>
.v-container {
  padding-top: 16px;
}

.v-card {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  margin: 0 auto;
}
</style>
